import { MapViewerService } from '@3ddv/ngx-dvm-internal';
import { InjectionToken } from '@angular/core';

/**
 * Secondary MapViewer instance used to resolve neighbor/related map metadata without
 * disrupting the on-screen viewer (same pattern as SMP relocate).
 */
export const BG_MAP_VIEWER_TOKEN = new InjectionToken<MapViewerService>(
  'BG_MAP_VIEWER_TOKEN'
);
